import React from 'react';
import { Box, VStack, Text, Heading, Icon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FiCreditCard } from 'react-icons/fi';
import { useTranslation } from '../../hooks/useTranslation';
import Button from './Button';

export interface PaySubscriptionGateProps {
    /** Вызывается перед переходом на экран оплаты по клику «Оплатить» */
    onPay?: () => void;
}

/**
 * Блок-заглушка: крупная иконка, заголовок, текст и кнопка «Оплатить» (переход на /payment/pay).
 * Показывается на экранах, когда у клиента статус new и контент недоступен без оплаты подписки.
 */
export const PaySubscriptionGate: React.FC<PaySubscriptionGateProps> = ({ onPay }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handlePay = () => {
        onPay?.();
        navigate('/payment/pay');
    };

    return (
        <Box flex={1} display="flex" alignItems="center" justifyContent="center" px={4} py={8}>
            <VStack gap={6} align="center" maxW="sm" textAlign="center">
                <Icon as={FiCreditCard} boxSize={16} color="yellow.600" />
                <Heading size="lg" color="gray.800">
                    {t.pages.payment.paySubscriptionTitle}
                </Heading>
                <Text fontSize="md" color="gray.600">
                    {t.pages.payment.paySubscriptionMessage}
                </Text>
                <Button type="button" buttonType="success" w="full" size="lg" onClick={handlePay}>
                    {t.pages.payment.pay}
                </Button>
            </VStack>
        </Box>
    );
};
